export const conveyancingInfo = [
  {
    title: 'Unlimited Contract Reviews and Negotiations by Expert Solicitors',
    description:
      'Get unlimited contract reviews and negotiations handled by qualified Solicitors, not just conveyancers. Our legal expertise goes beyond basic conveyancing to protect your interests at every step.',
    icon: 'preapproval',
  },
  {
    title: 'Faster Settlements Working Alongside Odin Mortgage Team',
    description:
      'Experience faster settlements through our 100% integrated mortgage, tax and conveyancing teams working in perfect sync. One unified team means no communication gaps and quicker turnaround times.',
    icon: 'preapproval',
  },
  {
    title: 'Expat Specialists in Overseas Conveyancing Transactions',
    description:
      'Our expat-focused team understands the unique challenges of overseas property transactions. We handle international verification of identity (VOI), document witnessing, and time zone coordination to make buying property from abroad seamless.',
    icon: 'preapproval',
  },
  {
    title: 'Australia-Wide Digital Services Supporting Expats',
    description:
      'Access premium conveyancing services from anywhere in Australia through our advanced digital platform. Complete your entire property transaction remotely with the same level of expertise and personal attention.',
    icon: 'preapproval',
  },
  {
    title: 'End-to-End Property Solutions for Australians Buying Overseas',
    description:
      'From contract negotiations to final settlement, we handle every aspect of your property transaction. Our comprehensive service includes title searches, document preparation, settlement coordination, and post-settlement follow-up.',
    icon: 'preapproval',
  },
];
